import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getDayListInMonth } from './util';
import { _$ } from '../util/domHelper';
import './style.css';
var weekDayArr = ['日', '一', '二', '三', '四', '五', '六'];

var Calendar = /*#__PURE__*/function () {
  function Calendar(option) {
    _classCallCheck(this, Calendar);

    this.option = _objectSpread({}, option);
  }

  _createClass(Calendar, [{
    key: "show",
    value: function show() {
      var container = _$(this.option.containerID);

      if (container) {
        container.innerHTML = this.createCal();
      }
    }
  }, {
    key: "renderHead",
    value: function renderHead() {
      var headContent = weekDayArr.map(function (item) {
        return "<div class=\"weekday-wrapper\">".concat(item, "</div>");
      }).join('\n');
      return "\n            <div class=\"calendar-head\">\n                ".concat(headContent, "\n            </div>\n        ");
    }
  }, {
    key: "renderDay",
    value: function renderDay(day) {
      var classlist = 'day-wrapper';

      if (day.type !== 'current') {
        classlist += ' inactive';
      }

      if (day.selected) {
        classlist += ' selected';
      }

      if (day.special) {
        classlist += ' special';
      }

      return "<div  class=\"".concat(classlist, "\">").concat(day.value, "</div>");
    }
  }, {
    key: "renderWeek",
    value: function renderWeek(week) {
      var _this = this;

      var weekContent = week.map(function (day) {
        return _this.renderDay(day);
      }).join('\n');
      return "\n            <div class=\"week-wrapper\"}>\n                ".concat(weekContent, "\n            </div>\n        ");
    }
  }, {
    key: "renderDayList",
    value: function renderDayList() {
      var _this2 = this;

      var _ref = this.option || {},
          year = _ref.year,
          month = _ref.month,
          selectedDays = _ref.selectedDays,
          specialDays = _ref.specialDays;

      var dayList = getDayListInMonth(year, month, selectedDays, specialDays) || [];
      var dayListStr = dayList.map(function (week) {
        return _this2.renderWeek(week);
      }).join('\n');
      return "\n            <div class=\"calendar-day-list\">\n                ".concat(dayListStr, "\n            </div>\n        ");
    }
  }, {
    key: "createCal",
    value: function createCal() {
      return "    \n        <div class=\"milo-calendar-container\">  \n            ".concat(this.renderHead(), "\n            ").concat(this.renderDayList(), "\n        </div> \n        ");
    }
  }]);

  return Calendar;
}();

export { Calendar as default };